import { all } from 'redux-saga/effects'

import { addOrderCommentSagaWatcher } from './add_order_comment.saga'
import { approveOrderSagaWatcher } from './approve_order.saga'
import { cancelOrderSagaWatcher } from './cancel_order.saga'
import { deleteOrderCommentSagaWatcher } from './delete_order_comment.saga'
import { deliverOrderSagaWatcher } from './deliver_order.saga'
import { dispatchOrderSagaWatcher } from './dispatch_order.saga'
import { getActiveOrdersVenueSagaWatcher } from './get_active_orders_of_venue.saga'
import { getAllOrdersSagaWatcher } from './get_all_orders.saga'
import { getDeliveredOrdersOfVenueSagaWatcher } from './get_delivered_orders_of_venue.saga'
import { getOrderSagaWatcher } from './get_order.saga'
import { getOrdersOfUserSagaWatcher } from './get_orders_of_user.saga'
import { getPastOrdersVenueSagaWatcher } from './get_past_orders_of_venue.saga'
import { getPastUsersOrdersVenueSagaWatcher } from './get_past_users_orders_of_venue.saga'
import { loadMoreOrdersOfUserSagaWatcher } from './load_more_orders_of_user.saga'
import { placeOrderSagaWatcher } from './place_order.saga'
import { rejectOrderSagaWatcher } from './reject_order.saga'
import { setSelectedOrderSagaWatcher } from './set_selected_order.saga'
import { unCancelOrderSagaWatcher } from './uncancel_order.saga'
import { unDeliverOrderSagaWatcher } from './undeliver_order.saga'
import { unDispatchOrderSagaWatcher } from './undispatch_order.saga'
import { unUsePointSagaWatcher } from './unuse_point.saga'
import { updateOrderSagaWatcher } from './update_order.saga'
import { usePointSagaWatcher } from './use_point.saga'

export default function * orderSaga () {
  yield all([
    approveOrderSagaWatcher(),
    cancelOrderSagaWatcher(),
    unCancelOrderSagaWatcher(),
    deliverOrderSagaWatcher(),
    dispatchOrderSagaWatcher(),
    getAllOrdersSagaWatcher(),
    getDeliveredOrdersOfVenueSagaWatcher(),
    getOrderSagaWatcher(),
    loadMoreOrdersOfUserSagaWatcher(),
    getOrdersOfUserSagaWatcher(),
    getActiveOrdersVenueSagaWatcher(),
    getPastOrdersVenueSagaWatcher(),
    getPastUsersOrdersVenueSagaWatcher(),
    placeOrderSagaWatcher(),
    rejectOrderSagaWatcher(),
    setSelectedOrderSagaWatcher(),
    unDeliverOrderSagaWatcher(),
    unDispatchOrderSagaWatcher(),
    updateOrderSagaWatcher(),
    usePointSagaWatcher(),
    unUsePointSagaWatcher(),
    addOrderCommentSagaWatcher(),
    deleteOrderCommentSagaWatcher()
  ])
}
